let _initProto, _initClass, _init_label, _init_extra_label, _init_index, _init_extra_index, _init_autoplay, _init_extra_autoplay, _init_interval, _init_extra_interval, _init_transition, _init_extra_transition, _init_controlsVariant, _init_extra_controlsVariant, _init_showIndicators, _init_extra_showIndicators, _init_showRotationControl, _init_extra_showRotationControl, _init_loop, _init_extra_loop, _init_wrap, _init_extra_wrap, _init_slideCount, _init_extra_slideCount;
function _applyDecs(e, t, n, r, o, i) { var a, c, u, s, f, l, p, d = Symbol.metadata || Symbol.for("Symbol.metadata"), m = Object.defineProperty, h = Object.create, y = [h(null), h(null)], v = t.length; function g(t, n, r) { return function (o, i) { n && (i = o, o = e); for (var a = 0; a < t.length; a++) i = t[a].apply(o, r ? [i] : []); return r ? i : o; }; } function b(e, t, n, r) { if ("function" != typeof e && (r || void 0 !== e)) throw new TypeError(t + " must " + (n || "be") + " a function" + (r ? "" : " or undefined")); return e; } function applyDec(e, t, n, r, o, i, u, s, f, l, p) { function d(e) { if (!p(e)) throw new TypeError("Attempted to access private element on non-instance"); } var h = [].concat(t[0]), v = t[3], w = !u, D = 1 === o, S = 3 === o, j = 4 === o, E = 2 === o; function I(t, n, r) { return function (o, i) { return n && (i = o, o = e), r && r(o), P[t].call(o, i); }; } if (!w) { var P = {}, k = [], F = S ? "get" : j || D ? "set" : "value"; if (f ? (l || D ? P = { get: _setFunctionName(function () { return v(this); }, r, "get"), set: function (e) { t[4](this, e); } } : P[F] = v, l || _setFunctionName(P[F], r, E ? "" : F)) : l || (P = Object.getOwnPropertyDescriptor(e, r)), !l && !f) { if ((c = y[+s][r]) && 7 !== (c ^ o)) throw Error("Decorating two elements with the same name (" + P[F].name + ") is not supported yet"); y[+s][r] = o < 3 ? 1 : o; } } for (var N = e, O = h.length - 1; O >= 0; O -= n ? 2 : 1) { var T = b(h[O], "A decorator", "be", !0), z = n ? h[O - 1] : void 0, A = {}, H = { kind: ["field", "accessor", "method", "getter", "setter", "class"][o], name: r, metadata: a, addInitializer: function (e, t) { if (e.v) throw new TypeError("attempted to call addInitializer after decoration was finished"); b(t, "An initializer", "be", !0), i.push(t); }.bind(null, A) }; if (w) c = T.call(z, N, H), A.v = 1, b(c, "class decorators", "return") && (N = c);else if (H.static = s, H.private = f, c = H.access = { has: f ? p.bind() : function (e) { return r in e; } }, j || (c.get = f ? E ? function (e) { return d(e), P.value; } : I("get", 0, d) : function (e) { return e[r]; }), E || S || (c.set = f ? I("set", 0, d) : function (e, t) { e[r] = t; }), N = T.call(z, D ? { get: P.get, set: P.set } : P[F], H), A.v = 1, D) { if ("object" == typeof N && N) (c = b(N.get, "accessor.get")) && (P.get = c), (c = b(N.set, "accessor.set")) && (P.set = c), (c = b(N.init, "accessor.init")) && k.unshift(c);else if (void 0 !== N) throw new TypeError("accessor decorators must return an object with get, set, or init properties or undefined"); } else b(N, (l ? "field" : "method") + " decorators", "return") && (l ? k.unshift(N) : P[F] = N); } return o < 2 && u.push(g(k, s, 1), g(i, s, 0)), l || w || (f ? D ? u.splice(-1, 0, I("get", s), I("set", s)) : u.push(E ? P[F] : b.call.bind(P[F])) : m(e, r, P)), N; } function w(e) { return m(e, d, { configurable: !0, enumerable: !0, value: a }); } return void 0 !== i && (a = i[d]), a = h(null == a ? null : a), f = [], l = function (e) { e && f.push(g(e)); }, p = function (t, r) { for (var i = 0; i < n.length; i++) { var a = n[i], c = a[1], l = 7 & c; if ((8 & c) == t && !l == r) { var p = a[2], d = !!a[3], m = 16 & c; applyDec(t ? e : e.prototype, a, m, d ? "#" + p : _toPropertyKey(p), l, l < 2 ? [] : t ? s = s || [] : u = u || [], f, !!t, d, r, t && d ? function (t) { return _checkInRHS(t) === e; } : o); } } }, p(8, 0), p(0, 0), p(8, 1), p(0, 1), l(u), l(s), c = f, v || w(e), { e: c, get c() { var n = []; return v && [w(e = applyDec(e, [t], r, e.name, 5, n)), g(n, 1)]; } }; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _setFunctionName(e, t, n) { "symbol" == typeof t && (t = (t = t.description) ? "[" + t + "]" : ""); try { Object.defineProperty(e, "name", { configurable: !0, value: n ? n + " " + t : t }); } catch (e) {} return e; }
function _checkInRHS(e) { if (Object(e) !== e) throw TypeError("right-hand side of 'in' should be an object, got " + (null !== e ? typeof e : "null")); return e; }
import { RadiantElement, customElement, onEvent, onUpdated, prop } from "@ecopages/radiant";
export const CAROUSEL_DEFAULTS = {
  label: "Carousel",
  transition: "none",
  controlsVariant: "toolbar"
};
const SWIPE_THRESHOLD_PX = 48;
let _RuiCarousel;
class RuiCarousel extends RadiantElement {
  static {
    ({
      e: [_init_label, _init_extra_label, _init_index, _init_extra_index, _init_autoplay, _init_extra_autoplay, _init_interval, _init_extra_interval, _init_transition, _init_extra_transition, _init_controlsVariant, _init_extra_controlsVariant, _init_showIndicators, _init_extra_showIndicators, _init_showRotationControl, _init_extra_showRotationControl, _init_loop, _init_extra_loop, _init_wrap, _init_extra_wrap, _init_slideCount, _init_extra_slideCount, _initProto],
      c: [_RuiCarousel, _initClass]
    } = _applyDecs(this, [customElement("rui-carousel")], [[prop({
      type: String,
      defaultValue: CAROUSEL_DEFAULTS.label
    }), 0, "label"], [prop({
      type: Number,
      reflect: true,
      defaultValue: 0
    }), 0, "index"], [prop({
      type: Boolean,
      reflect: true,
      defaultValue: false
    }), 0, "autoplay"], [prop({
      type: Number,
      defaultValue: 4e3
    }), 0, "interval"], [prop({
      type: String,
      defaultValue: CAROUSEL_DEFAULTS.transition
    }), 0, "transition"], [prop({
      type: String,
      defaultValue: CAROUSEL_DEFAULTS.controlsVariant,
      attribute: "controls-variant"
    }), 0, "controlsVariant"], [prop({
      type: Boolean,
      defaultValue: false
    }), 0, "showIndicators"], [prop({
      type: Boolean,
      defaultValue: false
    }), 0, "showRotationControl"], [prop({
      type: Boolean,
      defaultValue: true
    }), 0, "loop"], [prop({
      type: Boolean,
      defaultValue: true
    }), 0, "wrap"], [prop({
      type: Number,
      defaultValue: 0
    }), 0, "slideCount"], [onUpdated(["index", "transition", "loop", "wrap", "controlsVariant"]), 2, "onSlideStateUpdated"], [onUpdated(["autoplay", "showRotationControl", "interval"]), 2, "onAutoplayUpdated"], [onUpdated(["showIndicators"]), 2, "onIndicatorsUpdated"], [onEvent({
      selector: '[data-carousel-action="prev"]',
      type: "click"
    }), 2, "prev"], [onEvent({
      selector: '[data-carousel-action="next"]',
      type: "click"
    }), 2, "next"], [onEvent({
      selector: '[data-carousel-action="rotation"]',
      type: "click"
    }), 2, "toggleRotation"], [onEvent({
      selector: "[data-carousel-indicator]",
      type: "click"
    }), 2, "onIndicatorClick"], [onEvent({
      selector: "[data-carousel-indicator]",
      type: "keydown"
    }), 2, "onIndicatorKeydown"], [onEvent({
      ref: "root",
      type: "pointerenter"
    }), 2, "onRootPointerEnter"], [onEvent({
      ref: "root",
      type: "pointerleave"
    }), 2, "onRootPointerLeave"], [onEvent({
      ref: "root",
      type: "focusin"
    }), 2, "onRootFocusIn"], [onEvent({
      ref: "root",
      type: "focusout"
    }), 2, "onRootFocusOut"], [onEvent({
      ref: "viewport",
      type: "pointerdown"
    }), 2, "onViewportPointerDown"], [onEvent({
      ref: "viewport",
      type: "pointermove"
    }), 2, "onViewportPointerMove"], [onEvent({
      ref: "viewport",
      type: "pointerup"
    }), 2, "onViewportPointerUp"], [onEvent({
      ref: "viewport",
      type: "pointercancel"
    }), 2, "onViewportPointerCancel"]], 0, void 0, RadiantElement));
  }
  label = (_initProto(this), _init_label(this));
  index = (_init_extra_label(this), _init_index(this));
  autoplay = (_init_extra_index(this), _init_autoplay(this));
  interval = (_init_extra_autoplay(this), _init_interval(this));
  transition = (_init_extra_interval(this), _init_transition(this));
  controlsVariant = (_init_extra_transition(this), _init_controlsVariant(this));
  showIndicators = (_init_extra_controlsVariant(this), _init_showIndicators(this));
  showRotationControl = (_init_extra_showIndicators(this), _init_showRotationControl(this));
  loop = (_init_extra_showRotationControl(this), _init_loop(this));
  wrap = (_init_extra_loop(this), _init_wrap(this));
  slideCount = (_init_extra_wrap(this), _init_slideCount(this));
  timer = (_init_extra_slideCount(this), null);
  paused = false;
  /** User explicitly resumed rotation (e.g. via rotation control) despite reduced motion. */
  userOverrideReducedMotion = false;
  swipePointerId = null;
  swipeStartX = 0;
  swipeStartY = 0;
  onConnected() {
    if (this.autoplay && this.prefersReducedMotion()) {
      this.paused = true;
    }
    this.sync();
    this.syncAutoplay();
    this.syncIndicators();
    this.syncAriaLive();
  }
  disconnectedCallback() {
    this.stop();
    super.disconnectedCallback();
  }
  onSlideStateUpdated() {
    this.sync();
    this.syncIndicators();
    this.syncAutoplay();
  }
  onAutoplayUpdated() {
    this.syncAutoplay();
    this.syncRotationControl();
  }
  onIndicatorsUpdated() {
    this.syncIndicators();
  }
  prefersReducedMotion() {
    return typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }
  getCarouselId() {
    return this.id || "rui-carousel";
  }
  slidePanelId(slide, index) {
    const key = slide.getAttribute("data-slide") ?? String(index);
    const panelId = `${this.getCarouselId()}-panel-${key}`;
    slide.id = panelId;
    return panelId;
  }
  tabId(index) {
    return `${this.getCarouselId()}-tab-${index}`;
  }
  syncSlideAccessibility(slides, activeIndex) {
    const count = slides.length;
    slides.forEach((slide, i) => {
      const active = i === activeIndex;
      const positionLabel = `${i + 1} of ${count}`;
      if (this.showIndicators) {
        this.slidePanelId(slide, i);
        slide.setAttribute("role", "tabpanel");
        slide.setAttribute("aria-labelledby", this.tabId(i));
        slide.setAttribute("aria-label", positionLabel);
        slide.removeAttribute("aria-roledescription");
      } else {
        slide.setAttribute("role", "group");
        slide.setAttribute("aria-roledescription", "slide");
        slide.setAttribute("aria-label", positionLabel);
        slide.removeAttribute("aria-labelledby");
        slide.removeAttribute("tabindex");
      }
      if (this.transition === "none") {
        slide.hidden = !active;
      } else {
        slide.hidden = false;
      }
      slide.setAttribute("aria-hidden", String(!active));
      slide.setAttribute("data-active", active ? "true" : "false");
    });
  }
  getSlides() {
    return Array.from(this.querySelectorAll("[data-slide]"));
  }
  get shouldWrap() {
    return this.wrap && this.loop;
  }
  normalizeIndex(raw, count) {
    if (count <= 0) {
      return 0;
    }
    if (!this.shouldWrap) {
      return Math.min(Math.max(raw, 0), count - 1);
    }
    return (raw % count + count) % count;
  }
  sync() {
    const slides = this.getSlides();
    if (!slides.length) {
      return;
    }
    const normalized = this.normalizeIndex(this.index, slides.length);
    if (normalized !== this.index) {
      this.index = normalized;
    }
    const track = this.querySelector(".rui-carousel__track");
    if (track && this.transition === "slide") {
      track.style.setProperty("--rui-carousel-index", String(normalized));
    }
    this.syncSlideAccessibility(slides, normalized);
    this.syncPrevNextDisabled(slides.length, normalized);
  }
  syncPrevNextDisabled(count, normalized) {
    const disablePrev = !this.shouldWrap && count > 0 && normalized <= 0;
    const disableNext = !this.shouldWrap && count > 0 && normalized >= count - 1;
    for (const button of this.querySelectorAll('[data-carousel-action="prev"]')) {
      if (this.shouldWrap) {
        button.removeAttribute("disabled");
      } else {
        button.disabled = disablePrev;
      }
    }
    for (const button of this.querySelectorAll('[data-carousel-action="next"]')) {
      if (this.shouldWrap) {
        button.removeAttribute("disabled");
      } else {
        button.disabled = disableNext;
      }
    }
  }
  syncIndicators() {
    const container = this.querySelector('[data-ref="indicators"]');
    if (!container) {
      return;
    }
    const slides = this.getSlides();
    const normalized = this.normalizeIndex(this.index, slides.length);
    const existing = Array.from(container.querySelectorAll("[data-carousel-indicator]"));
    if (existing.length !== slides.length) {
      container.replaceChildren(...slides.map((slide, i) => {
        const button = document.createElement("button");
        button.type = "button";
        button.className = "rui-carousel__indicator";
        button.id = this.tabId(i);
        button.setAttribute("role", "tab");
        button.setAttribute("data-carousel-indicator", String(i));
        button.setAttribute("aria-controls", this.slidePanelId(slide, i));
        button.setAttribute("aria-label", `Slide ${i + 1}`);
        return button;
      }));
    }
    const indicators = Array.from(container.querySelectorAll("[data-carousel-indicator]"));
    indicators.forEach((indicator, i) => {
      const selected = i === normalized;
      const slide = slides[i];
      if (slide) {
        indicator.id = this.tabId(i);
        indicator.setAttribute("aria-controls", this.slidePanelId(slide, i));
      }
      indicator.setAttribute("aria-selected", String(selected));
      indicator.tabIndex = selected ? 0 : -1;
    });
  }
  syncRotationControl() {
    for (const toggle of this.querySelectorAll('[data-carousel-action="rotation"]')) {
      const playing = this.autoplay && !this.paused;
      toggle.setAttribute("aria-pressed", String(playing));
      toggle.setAttribute("aria-label", playing ? "Pause rotation" : "Start rotation");
    }
  }
  syncAriaLive() {
    const viewport = this.querySelector('[data-ref="viewport"]');
    if (!viewport) {
      return;
    }
    const rotating = this.autoplay && !this.paused && this.timer !== null;
    viewport.setAttribute("aria-live", rotating ? "off" : "polite");
    viewport.setAttribute("aria-atomic", "false");
  }
  canAutoplayRotate() {
    if (!this.autoplay || this.paused) {
      return false;
    }
    if (this.prefersReducedMotion() && !this.userOverrideReducedMotion) {
      return false;
    }
    return true;
  }
  syncAutoplay() {
    if (this.canAutoplayRotate()) {
      this.start();
    } else {
      this.stop();
    }
    this.syncRotationControl();
    this.syncAriaLive();
  }
  start() {
    const slides = this.getSlides();
    if (!slides.length) {
      return;
    }
    if (!this.shouldWrap && this.index >= slides.length - 1) {
      this.stop();
      return;
    }
    this.stop();
    const ms = Math.max(0, this.interval);
    this.timer = setInterval(() => {
      const currentSlides = this.getSlides();
      if (!currentSlides.length) {
        return;
      }
      if (!this.shouldWrap && this.index >= currentSlides.length - 1) {
        this.stop();
        this.syncAriaLive();
        return;
      }
      this.goTo(this.index + 1);
    }, ms);
    this.syncAriaLive();
  }
  stop() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.timer = null;
    this.syncAriaLive();
  }
  goTo(next) {
    const slides = this.getSlides();
    if (!slides.length) {
      return;
    }
    this.index = this.normalizeIndex(next, slides.length);
    this.sync();
    this.syncIndicators();
  }
  userNavigate(delta) {
    this.paused = true;
    this.stop();
    this.goTo(this.index + delta);
  }
  isSwipeExcludedTarget(target) {
    if (!(target instanceof Element)) {
      return false;
    }
    return Boolean(target.closest("button, a, input, textarea, select, [data-carousel-indicator], [data-carousel-action]"));
  }
  prev() {
    this.userNavigate(-1);
  }
  next() {
    this.userNavigate(1);
  }
  toggleRotation() {
    if (!this.autoplay) {
      this.autoplay = true;
      this.paused = false;
      this.userOverrideReducedMotion = true;
    } else {
      this.paused = !this.paused;
      if (!this.paused) {
        this.userOverrideReducedMotion = true;
      }
    }
    this.syncAutoplay();
  }
  onIndicatorClick(event) {
    const button = event.target.closest("[data-carousel-indicator]");
    if (!button) {
      return;
    }
    const indicatorIndex = Number(button.getAttribute("data-carousel-indicator"));
    if (!Number.isFinite(indicatorIndex)) {
      return;
    }
    this.paused = true;
    this.stop();
    this.goTo(indicatorIndex);
    button.focus();
  }
  onIndicatorKeydown(event) {
    const slides = this.getSlides();
    if (!slides.length) {
      return;
    }
    const current = event.target.closest("[data-carousel-indicator]");
    if (!current) {
      return;
    }
    let nextIndex = Number(current.getAttribute("data-carousel-indicator"));
    if (!Number.isFinite(nextIndex)) {
      return;
    }
    if (event.key === "ArrowRight") {
      nextIndex = this.normalizeIndex(nextIndex + 1, slides.length);
    } else if (event.key === "ArrowLeft") {
      nextIndex = this.normalizeIndex(nextIndex - 1, slides.length);
    } else if (event.key === "Home") {
      nextIndex = 0;
    } else if (event.key === "End") {
      nextIndex = slides.length - 1;
    } else if (event.key === " " || event.key === "Enter") {
      event.preventDefault();
      this.paused = true;
      this.stop();
      this.goTo(nextIndex);
      return;
    } else {
      return;
    }
    event.preventDefault();
    this.paused = true;
    this.stop();
    this.goTo(nextIndex);
    const indicators = Array.from(this.querySelectorAll('[data-ref="indicators"] [data-carousel-indicator]'));
    indicators[nextIndex]?.focus();
  }
  onRootPointerEnter(event) {
    if (this.autoplay && event.pointerType === "mouse") {
      this.stop();
    }
  }
  onRootPointerLeave(event) {
    if (this.autoplay && !this.paused && event.pointerType === "mouse") {
      this.syncAutoplay();
    }
  }
  onRootFocusIn() {
    if (this.autoplay) {
      this.stop();
    }
  }
  onRootFocusOut(event) {
    const next = event.relatedTarget;
    if (next && this.contains(next)) {
      return;
    }
    if (this.autoplay && !this.paused) {
      this.syncAutoplay();
    }
  }
  onViewportPointerDown(event) {
    if (event.button !== 0 || this.isSwipeExcludedTarget(event.target)) {
      return;
    }
    this.swipePointerId = event.pointerId;
    this.swipeStartX = event.clientX;
    this.swipeStartY = event.clientY;
  }
  onViewportPointerMove(event) {
    if (this.swipePointerId !== event.pointerId) {
      return;
    }
  }
  onViewportPointerUp(event) {
    if (this.swipePointerId !== event.pointerId) {
      return;
    }
    const dx = event.clientX - this.swipeStartX;
    const dy = event.clientY - this.swipeStartY;
    this.swipePointerId = null;
    if (Math.abs(dx) < SWIPE_THRESHOLD_PX || Math.abs(dx) <= Math.abs(dy)) {
      return;
    }
    if (dx < 0) {
      this.next();
    } else {
      this.prev();
    }
  }
  onViewportPointerCancel(event) {
    if (this.swipePointerId === event.pointerId) {
      this.swipePointerId = null;
    }
  }
  static {
    _initClass();
  }
}
export { _RuiCarousel as RuiCarousel };